import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { GET_DOMAIN } from 'features/inventory/api/queries/domain'
import { domainFromDTO } from 'features/inventory/mappers/domain'
import { Domain } from 'features/inventory/types/domain'
import { useAbility } from 'providers/casl'
import { DEFAULT_POOLING_INTERVAL } from 'providers/graphql/constants'
import { UseGetDomain, UseGetDomainProps } from './types'

export const useGetDomain = ({ id }: UseGetDomainProps): UseGetDomain => {
  const ability = useAbility()
  const [domain, setDomain] = useState<Domain>()

  const { loading } = useQuery(GET_DOMAIN({ ability }), {
    onCompleted: ({ node: domain }) => {
      if (domain) {
        setDomain(domainFromDTO(domain))
      }
    },
    pollInterval: DEFAULT_POOLING_INTERVAL,
    skip: !id,
    variables: { id: id! },
  })

  return { domain, loading }
}
